/*
    Please use the new recaptcha implementation going forward.
    File location: core-customize/hybris/bin/custom/tjxstorefront/web/webroot/WEB-INF/_fe-src/assets/js/refactor-modules/utilities/recaptcha/recaptcha.ts
    All necessary methods are still attached to the global ACC object - ACC.recaptcha
    The methods below are backup methods for loading the recaptcha script - legacy scripts and typescript scripts are loaded asynchronously,
    so sometimes the giftcard-related scripts need the methods below because the typescript files aren't fully loaded yet.
*/
'use strict';

var ACC;
ACC.recaptcha = window.ACC.recaptcha && window.ACC.recaptcha.execute ? window.ACC.recaptcha : {
    getRecaptchaLanguage: function() {
        var recaptchaLanguage = 'en-GB';
        switch (window.ACC.config.encodedContextPath) {
            case '/de/de':
                recaptchaLanguage = 'de';
                break;
            case '/at/de':
                recaptchaLanguage = 'de-AT';
        }
        return recaptchaLanguage;
    },

    loadScript: function() {
        var recaptchaScriptId = '__RECAPTCHA_SCRIPT';
        if (!document.getElementById(recaptchaScriptId)) {
            var recaptchaLanguage = ACC.recaptcha.getRecaptchaLanguage();
            const script = document.createElement('script');
            script.id = recaptchaScriptId;
            script.src = `https://www.google.com/recaptcha/api.js?onload=onRecaptchaLoaded&render=${window.ACC.config.captchaSiteKeyV3}&hl=${recaptchaLanguage}`;
            script.async = true;
            script.defer = true;
            document.head.appendChild(script);
        }
    },
}
